/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';
import SensorConsumptionResponse from './SensorConsumptionResponse';

/**
* The SearchCustomerTankResponse model module.
* @module model/SearchCustomerTankResponse
* @version 2020-12-7
*/
export default class SearchCustomerTankResponse {
    /**
    * Constructs a new <code>SearchCustomerTankResponse</code>.
    * 顧客タンク取得レスポンス
    * @alias module:model/SearchCustomerTankResponse
    * @class
    * @param customer {module:model/CustomerResponse} 
    * @param records {Array.<module:model/SensorConsumptionResponse>} 
    * @param result {module:model/SearchCustomerTankResponse.ResultEnum} 
    */

    constructor(customer, records, result) {
        
        
        this['customer'] = customer;
        this['records'] = records;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchCustomerTankResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchCustomerTankResponse} obj Optional instance to populate.
    * @return {module:model/SearchCustomerTankResponse} The populated <code>SearchCustomerTankResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchCustomerTankResponse();
                        
            
            if (data.hasOwnProperty('customer')) {
                obj['customer'] = CustomerResponse.constructFromObject(data['customer']);
            }
            if (data.hasOwnProperty('records')) {
                obj['records'] = ApiClient.convertToType(data['records'], [SensorConsumptionResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/CustomerResponse} customer
    */
    'customer' = undefined;
    /**
    * @member {Array.<module:model/SensorConsumptionResponse>} records
    */
    'records' = undefined;
    /**
    * @member {module:model/SearchCustomerTankResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
